import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Button } from '@r1-frontend/ui-kit/atoms/button';
import { Close } from '@r1-frontend/ui-kit/atoms/svg/main';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export type PopupHeaderProps = {
    children?: ReactNode,
    onClose: () => void,
    isCloseDisabled?: boolean,
    isShowClose?: boolean,
};

const PopupHeader = styled(({ children, onClose, isCloseDisabled, isShowClose = true, ...props }: PopupHeaderProps) => (
    <header {...props}>
        {isShowClose && <Button
            data-close-activator
            $small
            $type={'secondary'}
            icon={<Close/>}
            onClick={onClose}
            disabled={isCloseDisabled}
        />}
        {children}
    </header>
))`
    ${({ theme }: ThemedProperties) => css`
        button[data-close-activator] {
            float: right;
            margin-left: ${theme.indents.xxs}px;
        }
    `};
`;

PopupHeader.displayName = 'PopupHeader';

export { PopupHeader };
